import { useBalance } from "~/features/bank";
import type { PriceType } from "../types";

export const useCheckBalance = (price: PriceType) => {
    const { data: balance } = useBalance()
    const { usdc, point } = balance

    switch (price.currency.toLowerCase()) {
        case 'usdc':
            return usdc >= price.price
        case 'point':
            return point >= price.price
        default:
            return false
    }
}